import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { Loader2 } from 'lucide-react'
import { supabase } from '@/integrations/supabase/client'
import { toast } from 'sonner'

export const Route = createFileRoute('/auth/youtube-callback')({
  component: YouTubeCallback,
})

function YouTubeCallback() {
  const navigate = useNavigate()
  const called = useRef(false)

  useEffect(() => {
    if (called.current) return
    called.current = true

    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const state = params.get('state')
    const error = params.get('error')

    if (error) {
      toast.error(
        error === 'access_denied'
          ? 'Odmówiono dostępu do konta YouTube'
          : `Błąd autoryzacji: ${error}`,
      )
      navigate({ to: '/projekty' })
      return
    }

    if (!code || !state) {
      toast.error('Nieprawidłowe parametry autoryzacji YouTube')
      navigate({ to: '/projekty' })
      return
    }

    let projectId: string | undefined
    try {
      const statePayload = JSON.parse(atob(state))
      projectId = statePayload.projectId
      const savedState = sessionStorage.getItem(`yt_oauth_state_${projectId}`)
      if (savedState !== state) {
        toast.error('Błąd bezpieczeństwa — niezgodność parametru state')
        navigate({ to: '/projekty' })
        return
      }
      sessionStorage.removeItem(`yt_oauth_state_${projectId}`)
    } catch {
      toast.error('Nieprawidłowy parametr state')
      navigate({ to: '/projekty' })
      return
    }

    supabase.functions
      .invoke('youtube-oauth', { body: { action: 'callback', code, state } })
      .then(({ data, error: invokeError }) => {
        if (invokeError || !data?.success) {
          toast.error('Nie udało się połączyć z YouTube')
          navigate({
            to: '/projekty/$projectId/youtube-seo',
            params: { projectId: projectId! },
          })
          return
        }
        const channelName = data.channel_title ? ` (${data.channel_title})` : ''
        toast.success(`Połączono z YouTube${channelName}`)
        navigate({
          to: '/projekty/$projectId/youtube-seo',
          params: { projectId: data.project_id },
        })
      })
      .catch(() => {
        toast.error('Błąd połączenia z serwerem')
        navigate({ to: '/projekty' })
      })
  }, [navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <Loader2 className="h-10 w-10 animate-spin" style={{ color: 'var(--accent-primary)' }} />
      <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
        Łączę z kontem YouTube...
      </p>
    </div>
  )
}
